import React, {useState, useEffect} from 'react';
import {
    Container,
    Grid,
    Typography,
    Box,
    Button,
    FormControl,
    Input,
    FormLabel
} from '@mui/material';
import {styled} from '@mui/system';
import {useParams} from 'react-router-dom';
import tours from '../data/TourData';
import {DatePicker} from 'antd';

const StyledButton = styled(Button)({
    backgroundColor: '#00A2E8',
    color: 'white',
    '&:hover': {
        backgroundColor: '#008AC6',
    },
});

const TourDetail = () => {
    const {id} = useParams();
    const [tour, setTour] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [details, setDetails] = useState('');
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        const foundTour = tours.find(t => t.id === parseInt(id));
        if (foundTour) {
            setTour(foundTour);
            setSelectedImage(foundTour.images ? foundTour.images[0] : null);
            setDetails(foundTour.details);
            setTotalPrice(foundTour.price); // Initialize total price with base tour price
        }
    }, [id]);

    useEffect(() => {
        if (tour) {
            setTotalPrice((adults + children) * tour.price);
        }
    }, [adults, children, tour]);

    const handleImageSelect = (image) => {
        setSelectedImage(image);
    };

    if (!tour) {
        return <Typography variant="h5">Tour not found</Typography>;
    }

    return (
        <Container maxWidth="lg" style={{marginTop: '100px'}}>
            <Grid container spacing={2}>
                {/* Tour Detail Section */}
                <Grid item xs={12} md={8}>
                    <Typography style={{fontWeight: '600'}} variant="h4" gutterBottom>
                        {tour.title}
                    </Typography>

                    <Grid container spacing={1}>
                        <Grid item>
                            <Typography variant="body2">Time: {tour.time}</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2">Quantity: 13 people</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2">Age: 8+</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2">Review: There are no reviews yet</Typography>
                        </Grid>
                    </Grid>
                    <Box mt={2}>
                        <img
                            src={selectedImage}
                            alt="Tour Image"
                            style={{width: '100%', height: '390px', borderRadius: '10px'}}
                        />
                    </Box>

                    <Box mt={1} display="flex" justifyContent="space-between">
                        {tour.images && tour.images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Thumbnail ${index}`}
                                style={{width: '24%', cursor: 'pointer', borderRadius: '5px'}}
                                onClick={() => handleImageSelect(image)}
                            />
                        ))}
                    </Box>
                    <Box style={{margin: '50px 0'}} mt={1}>
                        <Typography variant="body1">
                            {details.split('\n').map((line, index) => (

                                <React.Fragment key={index}>
                                    {line.startsWith('Day') ? (
                                        <span className="bold-day">{line}</span>
                                    ) : (
                                        <span>{line}</span>
                                    )}
                                    <br/>
                                </React.Fragment>
                            ))}
                        </Typography>
                    </Box>
                </Grid>

                {/* Booking Section */}
                <Grid item xs={12} md={4}>
                    <Box border={1} borderColor="grey.300" borderRadius="10px" p={2}>
                        <Typography variant="h6" gutterBottom>Book this tour</Typography>
                        {/* DatePicker */}
                        <FormControl fullWidth margin="normal">
                            <DatePicker style={{width: '100%'}}/>
                        </FormControl>
                        {/* Input for Adults */}
                        <FormControl fullWidth margin="normal">
                            <FormLabel>Adult</FormLabel>
                            <Input
                                type="number"
                                value={adults}
                                onChange={(e) => setAdults(parseInt(e.target.value))}
                                inputProps={{min: 0}}
                            />
                        </FormControl>

                        {/* Input for Children */}
                        <FormControl fullWidth margin="normal">
                            <FormLabel>Children</FormLabel>
                            <Input
                                type="number"
                                value={children}
                                onChange={(e) => setChildren(parseInt(e.target.value))}
                                inputProps={{min: 0}}
                            />
                        </FormControl>
                        <Typography style={{marginTop: '10px'}} variant="h6" gutterBottom>
                            Price <span style={{color: '#00A2E8', float: 'right'}}>${totalPrice}</span>
                        </Typography>
                        {/* Book Now Button */}
                        <StyledButton variant="contained" fullWidth style={{marginTop: '16px'}}>
                            Book Now
                        </StyledButton>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default TourDetail;
